

@for (toast of notificationService.toasts; track toast) {
  @if (isTemplate(toast)) {
    <ngb-toast [autohide]="toast.autohide || true" [delay]="toast.delay || 5000" [ngClass]="{'bg-success': toast.type === 'success', 'bg-danger': toast.type === 'danger', 'bg-warning': toast.type === 'warning', 'text-light': toast.type === 'success' || toast.type === 'danger'}" (hide)="notificationService.removeToast(toast)">
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    </ngb-toast>
  } @else {
    <ngb-toast [autohide]="toast.autohide || true" [delay]="toast.delay || 5000" [ngClass]="{'bg-success': toast.type === 'success', 'bg-danger': toast.type === 'danger', 'bg-warning': toast.type === 'warning', 'text-light': toast.type === 'success' || toast.type === 'danger'}" (hide)="notificationService.removeToast(toast)">
      <ng-template ngbToastHeader>
        @if (toast.type === 'success') {
          <span><i class="fas fa-check-circle" aria-hidden="true"></i> Success</span>
        }
        @if (toast.type === 'danger') {
          <span><i class="fas fa-exclamation-circle" aria-hidden="true"></i> Error</span>
        }
        @if (toast.type === 'warning') {
          <span><i class="fas fa-exclamation-triangle" aria-hidden="true"></i> Warning</span>
        }
      </ng-template>
      <span [innerHTML]="toast.textOrTpl"></span>
    </ngb-toast>
  }
}
